export type FrontendLanguage =
  | 'de'
  | 'fr'
  | 'it'
  | 'en'
  | 'ch'
  | 'ua'
  | 'cz'
  | 'tr'
  | 'rs'
  | 'al'
  | 'es'
  | 'pt'
  | 'pl'
  | 'hu'
  | 'ro';

export const SUPPORTED_LANGS: FrontendLanguage[] = [
  'de',
  'fr',
  'it',
  'en',
  'ch',
  'es',
  'pt',
  'pl',
  'hu',
  'ro',
  'cz',
  'tr',
  'al',
  'ua',
  'rs',
];

export const SUPPORTED_LANGS_WITHOUT_SWISS_GERMAN: FrontendLanguage[] = [
  ...SUPPORTED_LANGS.filter((lang) => lang !== 'ch'),
];

export const FRONTEND_LANGUAGE_LABELS: { [key in FrontendLanguage]: string } = {
  de: 'Deutsch',
  fr: 'Français',
  it: 'Italiano',
  en: 'English',
  ch: 'Bärndütsch',
  ua: 'Yкраїнська',
  cz: 'Česky',
  tr: 'Türkçe',
  rs: 'Српскохрватски',
  al: 'Shqiptare',
  es: 'Español',
  pt: 'Português',
  pl: 'Polski',
  hu: 'Magyar',
  ro: 'Română',
};

export const MAIN_LANGS: FrontendLanguage[] = ['de', 'fr', 'it', 'en', 'ch'];

export const LANGUAGE_STORE_KEY = 'ssc-language';

// the default language for the translations => when a specific translation is missing in the current language,
// the translation in this language is used instead
// change as well in generateTranslationsJson.js
export const DEFAULT_TRANSLATION_LANG: FrontendLanguage = 'en';

// the default lang of the application => if we can't determine the user language, use this one
export const DEFAULT_LANG: FrontendLanguage = 'de';
